<template>
  <v-dialog overlay-opacity=".7" persistent v-model="internal" width="700">
    <v-card class="pa-4">
        <v-card-title>{{$t('broker.snackBar.partnerClientAdded')}}</v-card-title>
      <iframe
        :src="pdfURL + '#toolbar=0&navpanes=0&scrollbar=0'"
        width="100%"
        height="600px"
        style="border: none; scrollbar-width: none"
      ></iframe>
      <v-btn class="my-4" @click="closeModal" color="primary">OK</v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      pdfURL: "/pdf/tos_blank.pdf",
    };
  },
  computed: {
    internal: {
      get() {
        return this.value;
      },
      set(v) {
         this.$emit('input', v);
      },
    },
  },
  methods:{
    closeModal()
    {
        this.internal = false
        this.$emit('input', false)
    }
  }
};
</script>
